import { render, staticRenderFns } from "./WsContent.vue?vue&type=template&id=c05e2a54&"
import script from "./WsContent.vue?vue&type=script&lang=js&"
export * from "./WsContent.vue?vue&type=script&lang=js&"
import style0 from "./WsContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports